export const sanitizeInputValue = (value: string): string => {
  if (value.startsWith('00.')) return value.substring(1)
  if (value.startsWith('.') && value.length > 1) return String(Number(value))
  if (value.startsWith('<')) return value.substring(1)
  return value
}

export const isValidDecimal = (
  value: string,
  maxDecimalLength = 6,
): boolean => {
  const [_, digit] = value.split('.')
  if (!digit) return true
  return !digit.includes('.') && digit.length <= maxDecimalLength
}
